/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import React from 'react';
import {AppRoot, PageContainer} from './src/PageContainer';
import './src/polyfill';

const NO_LAYOUT_PATHS = ['/designs'];

export const wrapPageElement = ({element, props}) => {
  if (NO_LAYOUT_PATHS.includes(props.path)) {
    return element;
  }
  return <PageContainer {...props}>{element}</PageContainer>;
};

export const wrapRootElement = ({element}) => {
  return <AppRoot>{element}</AppRoot>;
};

// 添加 Gatsby V5 相容的 onRouteUpdate 函數
export const onRouteUpdate = ({location, prevLocation}) => {
  const widget = document.querySelector('div[script-id="UOmW9"]');
  if (widget) {
    if (location.pathname.includes('/designs')) {
      widget.style.display = 'none';
    } else {
      widget.style.display = 'block';
    }
  }
  if (process.env.NODE_ENV !== 'production') {
    console.log('路由更新:', location.pathname);
    console.log('前一個路由:', prevLocation ? prevLocation.pathname : null);
  }
};

// React 18 相容性設定
export const onClientEntry = () => {
  // 確保 React 18 的 Concurrent Mode 正常運作
  if (typeof window !== 'undefined') {
    // 初始化全域變數
    window.__GATSBY_INITIAL_PROPS = window.__GATSBY_INITIAL_PROPS || {};
  }
};
